import { useSelector } from 'react-redux'
import { selectClientId } from 'src/store/selectors/client'

export default (modulo = 2) => {
  const clientId = useSelector(selectClientId)
  return clientId ? parseInt(clientId.replace('-', ''), 16) % modulo : undefined
}
